import { OnInit, Component, ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { IResult } from 'app/shared/models/result.model';
import { AppConfig } from 'app/app.config';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoProduct } from 'app/shared/models/position/dto-product.model';
import { PositionService } from '../position.service';
import { ModalProductComponet } from 'app/views/modales/position/product/modal-product.component';

@Component({
    selector: 'app-products',
    styleUrls: ['./products.style.scss'],
    templateUrl: 'products.template.html'
})
export class ProductsComponent implements OnInit {
    private search: string;
    /**Modales */
    private modalRef: BsModalRef;
    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    /**Validadores */
    private errorMessages: any;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Variables */
    private now: number;
    /**Listas */
    private products = new Array() as IDtoProduct[];
    private productsTemp = new Array() as IDtoProduct[];
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tableProduct: DatatableComponent;
    public constructor(private configurationService: ConfigurationService
        , private spinner: NgxSpinnerService
        , private modalService: BsModalService
        , private serviceSecurity: SecurityService
        , private positionService: PositionService
        , private configGeneral: AppConfig) {
    }
    ngOnInit(): void {
        this.now = Date.now();
        if (this.configurationService.isReady) {
            this.spinner.show();
            this.getProducts()
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.spinner.show();
                this.getProducts()
            });
        }
    }
    private getProducts(): void {
        this.positionService.getProducts()
            .subscribe(
                (x) => {
                    this.products = x.data as IDtoProduct[];
                    this.productsTemp = x.data as IDtoProduct[];
                    this.spinner.hide();
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private openModalProduct(item: IDtoProduct, action: string) {
        const initialState = {
            product: item,
            title: action == 'edit' ? `Edición del producto ${item.name}` : `Nuevo producto`,
            action: action
        };
        this.modalRef = this.modalService.show(ModalProductComponet
            , Object.assign({ initialState }
                , this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.getProducts();
            } else {
                this.configGeneral.newToast('Error', 'Ocurrió un error al intentar guardar los datos, intente de nuevo', 'error');
            }
        });
    }
    private updateFilter() {
        if (this.search === undefined) {
            return;
        }
        const val = this.search.toLowerCase();
        const temp = this.productsTemp.filter((x: any) => x.name.toLowerCase().startsWith(val)
        || x.productTypeName.toLowerCase().startsWith(val));

        this.products = temp;
        this.tableProduct.offset = 0;
    }
}
